import { useEffect, useState } from "react";
import { db, auth } from "./firebase";
import {
  collection,
  query,
  where,
  getDocs,
  updateDoc,
  doc
} from "firebase/firestore";

function MyHouses({ goBack, onEdit }) {

  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    const fetchProperties = async () => {

      try {

        const q = query(
          collection(db, "houses"),
          where("ownerId", "==", auth.currentUser.uid)
        );

        const snap = await getDocs(q);

        setProperties(
          snap.docs
            .map((doc) => ({
              id: doc.id,
              ...doc.data()
            }))
            .filter(
              (property) =>
                property.status !== "closed"
            )
        );

      } catch (err) {

        console.log(err);

      } finally {

        setLoading(false);

      }

    };

    fetchProperties();

  }, []);

  const toggleStatus = async (id, currentStatus) => {

    const newStatus =
      currentStatus === "available"
        ? "closed"
        : "available";

    await updateDoc(
      doc(db, "houses", id),
      {
        status: newStatus
      }
    );

    if (newStatus === "closed") {

      // Remove advert immediately
      setProperties((prev) =>
        prev.filter(
          (property) => property.id !== id
        )
      );

    } else {

      setProperties((prev) =>
        prev.map((property) =>
          property.id === id
            ? {
                ...property,
                status: newStatus
              }
            : property
        )
      );

    };

  };

 const editProperty = (property) => {

  onEdit(property);

};
  if (loading) {

    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background:
            "linear-gradient(135deg,#000,#1a1a1a,#ffd600)"
        }}
      >
        <div
          style={{
            background: "white",
            padding: "40px",
            borderRadius: "20px",
            textAlign: "center",
            fontSize: "22px",
            fontWeight: "bold"
          }}
        >
          🏘️ Loading your properties...
        </div>
      </div>
    );

  }

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg,#000,#1a1a1a,#ffd600)",
        padding: "30px"
      }}
    >
      <button
        onClick={goBack}
        style={{
          background: "#ffd600",
          border: "none",
          padding: "12px 20px",
          borderRadius: "10px",
          fontWeight: "bold",
          cursor: "pointer",
          marginBottom: "20px"
        }}
      >
        ⬅ Back
      </button>

      <div
        style={{
          maxWidth: "900px",
          margin: "0 auto"
        }}
      >
        <h1
          style={{
            textAlign: "center",
            color: "white",
            marginBottom: "20px"
          }}
        >
          🏘️ My Properties
        </h1>

        <div
          style={{
            background: "#fff8d6",
            color: "#333",
            borderLeft: "6px solid #ffd600",
            padding: "18px",
            borderRadius: "12px",
            marginBottom: "30px",
            lineHeight: "1.7",
            fontSize: "16px",
            fontWeight: "500"
          }}
        >
          <strong>📢 NB:</strong> Once your house has been occupied,
          kindly close the advert to avoid unnecessary calls from
          people searching for houses.
        </div>

        {properties.length === 0 ? (

          <div
            style={{
              background: "white",
              padding: "35px",
              borderRadius: "20px",
              textAlign: "center",
              fontSize: "20px",
              fontWeight: "bold"
            }}
          >
            🎉 You currently have no active adverts.
          </div>

        ) : (

          properties.map((property) => (

            <div
              key={property.id}
              style={{
                background: "white",
                padding: "25px",
                borderRadius: "20px",
                marginBottom: "25px",
                boxShadow: "0 5px 15px rgba(0,0,0,0.15)"
              }}
            >
              <h2 style={{ marginBottom: "15px" }}>
                {property.plotName}
              </h2>

              <p><strong>Category:</strong> {property.propertyCategory}</p>

              <p><strong>Town:</strong> {property.town}</p>

              <p><strong>Area:</strong> {property.area}</p>

              <p>
                <strong>Estate:</strong>{" "}
                {property.estate || "Not Applicable"}
              </p>

              <p><strong>Type:</strong> {property.houseType}</p>

              <p><strong>Rent:</strong> KES {property.rent}</p>
<div
  style={{
    marginTop: "25px",
    background: "#fff8d6",
    padding: "18px",
    borderRadius: "15px",
    borderLeft: "6px solid #ffd600"
  }}
>
  <h2
    style={{
      marginTop: 0,
      marginBottom: "15px"
    }}
  >
    📞 Contact Details
  </h2>

  <p>
    <strong>Landlord:</strong>{" "}
    {property.landlordName || "Not provided"}
  </p>

 <p>
  <strong>Contact:</strong>{" "}
  <a
    href={`tel:${property.contact}`}
    style={{
      color: "#0066cc",
      textDecoration: "none",
      fontWeight: "bold"
    }}
  >
    {property.contact}
  </a>
</p>

 {property.email && (
  <p>
    <strong>Email:</strong>{" "}
    <a
      href={`mailto:${property.email}`}
      style={{
        color: "#0066cc",
        textDecoration: "none",
        fontWeight: "bold"
      }}
    >
      {property.email}
    </a>
  </p>
)}
</div>

              <p>
                <strong>Status:</strong> {property.status}
              </p>

              <div
                style={{
                  background: "#fff8d6",
                  borderLeft: "5px solid #ffd600",
                  padding: "12px",
                  borderRadius: "10px",
                  margin: "15px 0",
                  color: "#333",
                  fontSize: "15px",
                  lineHeight: "1.6"
                }}
              >
                <strong>NB:</strong> Once your house gets occupied,
                kindly close the advert to stop receiving enquiries.
              </div>

              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap"
                }}
              >
                <button
                  onClick={() =>
                    toggleStatus(
                      property.id,
                      property.status
                    )
                  }
                  style={{
                    background: "#d32f2f",
                    color: "white",
                    border: "none",
                    padding: "12px 18px",
                    borderRadius: "10px",
                    cursor: "pointer",
                    fontWeight: "bold"
                  }}
                >
                  🔒 Close Advert
                </button>

                <button
                  onClick={() =>
                    editProperty(property)
                  }
                  style={{
                    background: "#ffd600",
                    color: "black",
                    border: "none",
                    padding: "12px 18px",
                    borderRadius: "10px",
                    cursor: "pointer",
                    fontWeight: "bold"
                  }}
                >
                  ✏️ Edit Property
                </button>
              </div>
            </div>

          ))
          

        )}

      </div>

    </div>

  );

}

export default MyHouses;